var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_11445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C10.05 0 6 4.05 6 9C6 13.95 15 25.5 15 25.5C15 25.5 24 13.95 24 9C24 4.05 19.95 0 15 0ZM15 12C13.35 12 12 10.65 12 9C12 7.35 13.35 6 15 6C16.65 6 18 7.35 18 9C18 10.65 16.65 12 15 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.45 16.65C24 17.55 23.55 18.45 22.95 19.35C25.5 20.25 27 21.45 27 22.5C27 24.3 22.2 27 15 27C7.8 27 3 24.3 3 22.5C3 21.45 4.5 20.25 7.05 19.2C6.45 18.3 6 17.4 5.55 16.5C2.1 18 0 20.1 0 22.5C0 26.7 6.3 30 14.7 30C22.2 30 30 27.45 30 22.5C30 20.1 27.9 18 24.45 16.65Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_11445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepLocation);
export default __webpack_public_path__ + "static/media/step-location.b7ce2e70ddad1cddc0f38a28e95f8bd9.svg";
export { ForwardRef as ReactComponent };